import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Sirve para todos los años de la técnica?',
    a: 'Sí. Organizado de forma progresiva para 4°, 5° y 6° año con planificaciones diferenciadas por nivel de cursada.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Descargás los PDFs al instante. Podés imprimir, compartir por WhatsApp con tus alumnos o proyectar en el taller.'
  }, {
    q: '¿Necesito ser experto en mantenimiento para usarlo?',
    a: 'No. El material está diseñado para que puedas enseñar mantenimiento industrial aunque no tengas experiencia en planta. Todo está explicado paso a paso con criterio docente.'
  }, {
    q: '¿Qué lo diferencia de lo que hay en internet?',
    a: 'El material online es genérico, está en inglés o es para ingeniería universitaria. Este Kit fue creado para el taller de la escuela técnica argentina, con lógica pedagógica de nivel secundario técnico.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. 7 días para probarlo en el taller. Devolución del 100% sin preguntas ni formularios.'
  }, {
    q: '¿Sirve si soy maestro de taller y no profesor de teoría?',
    a: 'Absolutamente. Las actividades, checklists y fichas prácticas son el recurso central del maestro de taller. Los profesores de teoría usan los tomos, los casos de falla y el banco de evaluaciones.'
  }, {
    q: '¿Las plantillas son editables?',
    a: 'Sí. Los planes de mantenimiento, las planillas de seguimiento y las rúbricas vienen en formato editable para que las adaptes a tu institución.'
  }, {
    q: '¿Los casos de falla incluyen las soluciones?',
    a: 'Sí, todos los casos incluyen el análisis completo: síntoma, diagnóstico, causa raíz y solución documentada para que el docente tenga la referencia exacta al corregir.'
  }, {
    q: '¿Hay que pagar alguna mensualidad o suscripción?',
    a: 'No. Es un pago único. Comprás el kit hoy y te queda para siempre, con acceso de por vida a los archivos.'
  }, {
    q: '¿Qué medios de pago aceptan?',
    a: 'Aceptamos Mercado Pago, todas las tarjetas de crédito y débito, y transferencias bancarias. El pago es 100% seguro y el acceso es automático tras la confirmación.'
  }];
  return <section className="py-8 md:py-16 px-3 bg-brand-dark border-b border-white/10" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-8 text-white uppercase text-shadow-lg" data-id="element-56">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-3" data-id="element-57">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-card rounded-xl border-2 ${openIndex === index ? 'border-brand-accent' : 'border-white/10'} overflow-hidden transition-all duration-300 shadow-lg`} data-id="element-58">
              <button className="w-full px-4 py-4 md:px-6 md:py-5 text-left flex justify-between items-center focus:outline-none bg-brand-card hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-59">
                <span className={`font-black text-sm md:text-base pr-4 uppercase leading-tight ${openIndex === index ? 'text-brand-accent' : 'text-white'}`} data-id="element-60">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-brand-accent shrink-0" data-id="element-61" /> : <ChevronDown className="w-6 h-6 text-gray-500 shrink-0" data-id="element-62" />}
              </button>

              <div className={`px-4 md:px-6 overflow-hidden transition-all duration-300 ease-in-out bg-black ${openIndex === index ? 'max-h-96 py-4 opacity-100 border-t-2 border-white/10' : 'max-h-0 opacity-0'}`} data-id="element-63">
                <p className="text-sm md:text-base text-gray-300 leading-relaxed font-medium" data-id="element-64">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}